import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const indianShoresConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Indian Shores Tree Service | Sam\'s Tree Service',
  metaDescription: 'Professional tree trimming and removal in Indian Shores, FL. Sam\'s Tree Service handles dangerous coastal trees safely and affordably.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_indian_shores',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Indian Shores',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Indian Shores Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we handle the tree work that protects 
     homes and beachfront properties across <strong>Indian Shores</strong>. The narrow 
     barrier island setting means every overgrown tree or storm split limb is close 
     to a structure, a vehicle, or a neighbor's property. Our team works with the 
     precision and care that tight coastal lots demand getting the job done safely 
     without disrupting your property or the ones around it.`,

    `We specialize in <strong>hazardous tree removal and coastal trimming</strong>
     including large palms leaning from wind damage, hardwoods with salt weakened 
     root systems, canopy overgrowth near vacation rentals and primary residences, 
     and storm cleanup that gets your property back in order fast. We bring the 
     right equipment for every job regardless of how tight the access is.`,

    `<strong>Sam's Tree Service</strong> delivers dependable, professional tree care 
     throughout <strong>Indian Shores</strong> and across the <strong>Pinellas 
     Gulf beach</strong> communities keeping your coastal property safe, clean, 
     and well maintained all year long.`,
  ],
  ctaLabel: 'Get a Free Estimate!',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Indian Shores, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_IndianShores = () => <LocationPage config={indianShoresConfig} />;
export default Services_IndianShores;
